module.exports = __webpack_public_path__ + "img/two.5ce37970.png";